'use client'

import { LazyMotion } from 'framer-motion'
import type { ReactNode } from 'react'

const loadFeatures = () => import('@/lib/motion-features').then((mod) => mod.default)

/**
 * Components use the lightweight `m` API; the animation features (whileInView, hover/tap, exit)
 * load asynchronously after hydration instead of shipping in the critical bundle.
 */
export default function MotionProvider({ children }: { children: ReactNode }) {
  return <LazyMotion features={loadFeatures}>{children}</LazyMotion>
}
